import type { ConstsConfig } from '../declare'

const consts: ConstsConfig[] = [
  // ListSearch 搜索额外请求参数字段标识符
  {
    name: 'LIST_SEARCH_EXTRA_DATA_PREFIX',
    value: '__ex_search__'
  },
  // ListSearch 默认显示搜索项数量
  {
    name: 'LIST_SEARCH_SIMPLE_SEARCH_COUNTS',
    value: 3
  },
  // ListTable 序号列 key
  {
    name: 'LIST_TABLE_COLUMN_NO',
    value: 'list_table_column_no'
  },
  // ListTable 操作列 key
  {
    name: 'LIST_TABLE_COLUMN_OPERATE',
    value: 'list_table_column_operate'
  },
  /**
   * 按钮位置
   * 用于区分表格行按钮、表格头部按钮、页面配置按钮
   */
  // 列表行按钮
  {
    name: 'BTN_LOCATE_ROW',
    value: 'btn_locate_row'
  },
  // 列表头部按钮
  {
    name: 'BTN_LOCATE_HEADER',
    value: 'btn_locate_header'
  },
  // 页面配置按钮
  {
    name: 'BTN_LOCATE_PAGER',
    value: 'btn_locate_pager'
  },
  // 层级树侧边配置按钮
  {
    name: 'BTN_LOCATE_SIDER',
    value: 'btn_locate_sider'
  },
  /**
   * 控件位置
   * 用于区分列表行配置控件、列表查询配置控件、页面配置控件
   */
  // 列表行配置控件
  {
    name: 'CONTROL_LOCATE_ROW',
    value: 'control_locate_row'
  },
  // 列表查询配置控件
  {
    name: 'CONTROL_LOCATE_HEADER',
    value: 'control_locate_header'
  },
  // 页面配置控件
  {
    name: 'CONTROL_LOCATE_PAGER',
    value: 'control_locate_pager'
  },
  /**
   * 页面位置
   * 用于区分具体位置位于页面哪个地方
   */
  // 列表行子表列表页面
  {
    name: 'PAGE_LOCATE_LIST_ROW',
    value: 'page_locate_list_row'
  },
  /**
   * 功能类型
   * 用于标识特定功能类型
   */
  // 批量保存功能
  {
    name: 'FUNC_TYPE_BATCH_SAVE',
    value: 'func_type_batch_save'
  },
  /**
   * 表单类型
   */
  // 列表子表（该字段为前端自定义标记，非后端数据）
  {
    name: 'FORM_TYPE_LIST_SUBPAGE',
    value: -1
  },
  // 列表表单
  {
    name: 'FORM_TYPE_LIST_PAGE',
    value: 0
  },
  // 编辑表单
  {
    name: 'FORM_TYPE_EDIT_PAGE',
    value: 1
  },
  // 编辑树表单
  {
    name: 'FORM_TYPE_EDITTREE_PAGE',
    value: 2
  },
  // 图表表单
  {
    name: 'FORM_TYPE_CHART_PAGE',
    value: 3
  },
  // 树表单
  {
    name: 'FORM_TYPE_TREE_PAGE',
    value: 6
  },
  // 组合表单
  {
    name: 'FORM_TYPE_COMBINATION_PAGE',
    value: 7
  },
  // 可编辑列表表单
  {
    name: 'FORM_TYPE_EDITLIST_PAGE',
    value: 8
  },
  // 动态列可编辑列表表单
  {
    name: 'FORM_TYPE_DYNAMIC_EDITLIST_PAGE',
    value: 9
  },
  // 自定义页面
  {
    name: 'FORM_TYPE_CUSTOM_PAGE',
    value: 99
  },
  /**
  * 图表表单类型
  */
  // 折线图
  {
    name: 'CHART_TYPE_LINE',
    value: 0
  },
  // 柱状图
  {
    name: 'CHART_TYPE_BAR',
    value: 1
  },
  // 饼图
  {
    name: 'CHART_TYPE_PIE',
    value: 2
  },
  // 桑基图
  {
    name: 'CHART_TYPE_SAN',
    value: 3
  },
  // 雷达图
  {
    name: 'CHART_TYPE_RADAR',
    value: 4
  },
  /**
   * 树表单类型
   */
  // 横向树表单
  {
    name: 'TREE_TYPE_HORIZONTAL',
    value: 0
  },
  // 纵向树表单
  {
    name: 'TREE_TYPE_VERTICAL',
    value: 1
  },
  /**
   * 按钮类型
   */
  // 列表头部按钮
  {
    name: 'BTN_FUN_TYPE_HEADER',
    value: 0
  },
  // 列表行按钮
  {
    name: 'BTN_FUN_TYPE_ROW',
    value: 1
  },
  // 批量新增保存按钮
  {
    name: 'BTN_TYPE_BATCH_SAVE',
    value: -3
  },
  // Tree 新增同级按钮
  {
    name: 'BTN_TYPE_TREE_SAMELEVEL_ADD',
    value: -1
  },
  // 自定义表单按钮
  {
    name: 'BTN_TYPE_CUSTOM_PAGE',
    value: 0
  },
  // 保存按钮
  {
    name: 'BTN_TYPE_SAVE',
    value: 1
  },
  // 刷新按钮
  {
    name: 'BTN_TYPE_REFRESH',
    value: 2
  },
  // 新增按钮
  {
    name: 'BTN_TYPE_ADD',
    value: 3
  },
  // 删除按钮 
  {
    name: 'BTN_TYPE_DELETE',
    value: 4
  },
  // 编辑表单按钮
  {
    name: 'BTN_TYPE_EDIT_PAGE',
    value: 5
  },
  // 自定义事件按钮
  {
    name: 'BTN_TYPE_CUSTOM_EVT',
    value: 6
  },
  // 自定义按钮渲染
  {
    name: 'BTN_TYPE_CUSTOM_BTN',
    value: 7
  },
  // 查看按钮
  {
    name: 'BTN_TYPE_VIEW',
    value: 8
  },
  // 导出按钮
  {
    name: 'BTN_TYPE_EXPORT',
    value: 9
  },
  // 复制新增按钮
  {
    name: 'BTN_TYPE_COPY',
    value: 10
  },
  // 导入按钮
  {
    name: 'BTN_TYPE_IMPORT',
    value: 11
  },
  // 列表表单按钮
  {
    name: 'BTN_TYPE_LIST_PAGE',
    value: 12
  },
  // 批量新增按钮
  {
    name: 'BTN_TYPE_BATCH_ADD',
    value: 13
  },
  // 组合表单按钮
  {
    name: 'BTN_TYPE_MULTI_PAGE',
    value: 14
  },
  // 自定义导入按钮
  {
    name: 'BTN_TYPE_CUSTOM_IMPORT',
    value: 15
  },
  // 编辑树按钮
  {
    name: 'BTN_TYPE_EDITTREE_PAGE',
    value: 17
  },
  // 打印按钮
  {
    name: 'BTN_TYPE_PRINT',
    value: 18
  },
  /**
   * 列表表单控件类型（查询组件）
   */
  // 文本输入框
  {
    name: 'DATA_TYPE_TEXTINPUT',
    value: 1
  },
  // 数值输入框
  {
    name: 'DATA_TYPE_NUMBERINPUT',
    value: 2
  },
  // 枚举下拉单选框
  {
    name: 'DATA_TYPE_ENUM_SELECT',
    value: 3
  },
  // Switch 开关
  {
    name: 'DATA_TYPE_SWITCH',
    value: 4
  },
  // 枚举下拉多选框
  {
    name: 'DATA_TYPE_ENUM_MULTI_SELECT',
    value: 6
  },
  // 级联选择框，用树下拉实现
  {
    name: 'DATA_TYPE_CASCADER_SELECT',
    value: 8
  },
  // 分页下拉
  {
    name: 'DATA_TYPE_PAGINATION_SELECT',
    value: 11
  },
  // 树下拉
  {
    name: 'DATA_TYPE_TREE_SELECT',
    value: 14
  },
  // DATE 日期选择：精度到日
  {
    name: 'DATA_TYPE_DATE_DAY',
    value: 17
  },
  // DATE 日期区间选择：精度到日
  {
    name: 'DATA_TYPE_DATE_RANGE_DAY',
    value: 5
  },
  // DATE 月份选择：精度到月份
  {
    name: 'DATA_TYPE_DATE_MONTH',
    value: 9
  },
  // DATE 月份区间选择：精度到月份
  {
    name: 'DATA_TYPE_DATE_RANGE_MONTH',
    value: 10
  },
  // DATE 年度选择：精度到年份
  {
    name: 'DATA_TYPE_DATE_YEAR',
    value: 12
  },
  // DATE 年度区间选择：精度到年份
  {
    name: 'DATA_TYPE_DATE_RANGE_YEAR',
    value: 13
  },
  // DATE 秒区间选择：精度到秒
  {
    name: 'DATA_TYPE_DATE_RANGE_DAY_SECOND',
    value: 15
  },
  // DATE 分区间选择：精度到分
  {
    name: 'DATA_TYPE_DATE_RANGE_DAY_MINUTE',
    value: 16
  },
  /**
   * 列表表单控件类型（columns列控件）
   */
  // 文本
  {
    name: 'CONTROL_TYPE_TEXT',
    value: 0
  },
  /**
   * 编辑表单控件类型
   */
  // 文本输入框
  {
    name: 'CONTROL_TYPE_TEXTINPUT',
    value: 1
  },
  // 枚举下拉单选框
  {
    name: 'CONTROL_TYPE_ENUM_SELECT',
    value: 3
  },
  // 单选 Switch 控件
  {
    name: 'CONTROL_TYPE_SWITCH',
    value: 4
  },
  // 复选框控件
  {
    name: 'CONTROL_TYPE_CHECKBOX',
    value: 5
  },
  // 长文本输入框
  {
    name: 'CONTROL_TYPE_TEXTAREA',
    value: 6
  },
  // 数字输入框
  {
    name: 'CONTROL_TYPE_NUMBERINPUT',
    value: 7
  },
  // 分页下拉
  {
    name: 'CONTROL_TYPE_PAGINATION_SELECT',
    value: 9
  },
  // 树下拉
  {
    name: 'CONTROL_TYPE_TREE_SELECT',
    value: 11
  },
  // 系统序列号控件，用于生成序列号
  {
    name: 'CONTROL_TYPE_SERIES_NO',
    value: 14
  },
  // 密码控件
  {
    name: 'CONTROL_TYPE_PASSWORD',
    value: 16
  },
  // 级联下拉
  {
    name: 'CONTROL_TYPE_CASCADER_SELECT',
    value: 17
  },
  // 分页下拉多选
  {
    name: 'CONTROL_TYPE_PAGINATION_MULTI_SELECT',
    value: 24
  },
  // 附件上传
  {
    name: 'CONTROL_TYPE_ATTACH_UPLOAD',
    value: 25
  },
  // 文件上传
  {
    name: 'CONTROL_TYPE_FILE_UPLOAD',
    value: 200
  },
  // 图片/文件选择组件
  {
    name: 'CONTROL_TYPE_FILE_SELECT',
    value: 205
  },
  // 布尔值文本
  {
    name: 'CONTROL_TYPE_BOOL_TEXT',
    value: 101
  },
  // 数字输入框：两位小数精度
  {
    name: 'CONTROL_TYPE_NUMBERINPUT_TWODOT',
    value: 104
  },
  // 数字输入框：三位小数精度
  {
    name: 'CONTROL_TYPE_NUMBERINPUT_THREEDOT',
    value: 105
  },
  // DATE 日期选择：精度到秒
  {
    name: 'CONTROL_TYPE_DATE_DAY_SECOND',
    value: 15
  },
  // DATE 日期选择：精度到日
  {
    name: 'CONTROL_TYPE_DATE_DAY',
    value: 2
  },
  // DATE 日期区间选择：精度到日
  {
    name: 'CONTROL_TYPE_DATE_RANGE_DAY',
    value: 10
  },
  // DATE 月份选择：精度到月份
  {
    name: 'CONTROL_TYPE_DATE_MONTH',
    value: 18
  },
  // DATE 月份区间选择：精度到月份
  {
    name: 'CONTROL_TYPE_DATE_RANGE_MONTH',
    value: 19
  },
  // DATE 年度选择：精度到年份
  {
    name: 'CONTROL_TYPE_DATE_YEAR',
    value: 20
  },
  // DATE 年度区间选择：精度到年份
  {
    name: 'CONTROL_TYPE_DATE_RANGE_YEAR',
    value: 21
  },
  // DATE 时分秒选择：精度到秒
  {
    name: 'CONTROL_TYPE_DATE_SECOND',
    value: 8
  },
  // DATE 秒区间选择：精度到秒
  {
    name: 'CONTROL_TYPE_DATE_RANGE_DAY_SECOND',
    value: 22
  },
  // DATE 分区间选择：精度到分
  {
    name: 'CONTROL_TYPE_DATE_RANGE_DAY_MINUTE',
    value: 23
  },
  /**
   * 操作符类型
   */
  // 没有在枚举中看到这个值，但在代码中有
  {
    name: 'OPERATE_TYPE_ZERO',
    value: 0
  },
  // 等于
  {
    name: 'OPERATE_TYPE_EQUAL',
    value: 1
  },
  // 小于等于
  {
    name: 'OPERATE_TYPE_LESS_EQUAL',
    value: 4
  },
  // 大于等于
  {
    name: 'OPERATE_TYPE_GREATER_EQUAL',
    value: 6
  },
  // 包含
  {
    name: 'OPERATE_TYPE_INCLUDE',
    value: 9
  },
  /**
   * 状态类型
   */
  // 启用状态
  {
    name: 'ENABLE_STATUS_ENABLE',
    value: 0
  },
  // 禁用状态
  {
    name: 'ENABLE_STATUS_DISABLE',
    value: 1
  }
]

export default consts